<template>
  <div class="navbar-layout" ref="navbarId">
    <div class="navbar-content">
      <canvas id="canvas-2761" style="position: absolute; z-index: -1; left: 0px;top: 6px;"></canvas>
      <div class="navbar-title">太平洋科技集团信息化平台</div>
      <div class="sidebar-container-mian">
        <Sidebar @refreshAnimation="refreshAnimation" />
      </div>

      <div class="navbar-fixt"></div>

      <el-button
        v-if="systemMessage"
        type="text"
        class="system-message-broadcast"
        :aria-label="'打开系统消息：' + systemMessage.title"
        @click="openSystemMessage"
      >
        <i class="el-icon-message-solid"></i>
        <span class="system-message-broadcast-viewport">
          <span class="system-message-broadcast-track">
            <span>{{ systemMessage.title }}：{{ systemMessage.content }}</span>
            <span aria-hidden="true">{{ systemMessage.title }}：{{ systemMessage.content }}</span>
          </span>
        </span>
      </el-button>

      <div class="right-menu">
        <!--trigger="click"-->
        <el-dropdown class="right-menu-item hover-effect" @command="handleCommand">
          <div class="avatar-wrapper">
            <div class="user-name-mian">
              <div class="user-img"><i class="el-icon-s-custom"></i></div>
              <span class="user-name">{{
                account && account != "" ? account : "-"
              }}</span>
            </div>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="custom-navigation-main">

              <el-dropdown-item class="custom-navigation-design" command="changeNav">
                <i class="el-icon-message-solid"></i>企<span class="mar"></span>业<span class="mar"></span>管<span class="mar"></span>理</el-dropdown-item>

              <el-dropdown-item class="custom-navigation-design" command="toMap">
                <i class="el-icon-warning"></i>监测预警中心</el-dropdown-item><!--(<span style="color: red;">1000</span>)-->
              <el-dropdown-item class="custom-navigation-design">
                <i class="el-icon-lock"></i>
                修<span class="mar"></span>改<span class="mar"></span>密<span class="mar"></span>码</el-dropdown-item>

              <el-dropdown-item class="custom-navigation-design">
                <i class="el-icon-place"></i>
                版<span class="mar"></span>本：<span class="mar"></span>v1.0</el-dropdown-item>

              <el-dropdown-item class="custom-navigation-design">
                <i class="el-icon-position"></i>
                用<span class="mar"></span>户<span class="mar"></span>手<span class="mar"></span>册</el-dropdown-item>


              <el-dropdown-item divided>
                <el-button type="primary" class="logout" @click="outLogin">退出登录</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <el-dialog
      v-if="systemMessage"
      title="系统消息"
      :visible.sync="systemMessageVisible"
      width="560px"
      custom-class="system-message-dialog"
      :close-on-click-modal="false"
      :modal="false"
    >
      <div class="system-message-title">{{ systemMessage.title }}</div>
      <div class="system-message-meta">
        <el-tag size="mini" :type="systemMessage.level === 'IMPORTANT' ? 'danger' : systemMessage.level === 'WARNING' ? 'warning' : 'info'">
          {{ systemMessage.level === 'IMPORTANT' ? '重要' : systemMessage.level === 'WARNING' ? '警告' : '普通' }}
        </el-tag>
      </div>
      <div class="system-message-content">{{ systemMessage.content }}</div>
      <span slot="footer">
        <el-button type="primary" @click="systemMessageVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import VueCookies from "vue-cookies";
import { getLatestSystemMessage } from '@/api/systemMessage';
import Sidebar from "@/layout/components/Sidebar";
import url from "url";
export default {
  name: "Navbar",
  data() {
    return {
      account: "",
      companyName: "",
      systemMessage: null,
      systemMessageVisible: false,
      selectoptions: [],
      canvasnav: undefined
    };
  },
  components: { Sidebar },
  computed: {},
  created() {
    this.selectoptions = JSON.parse(localStorage.getItem("navItem"));
    const that = this;
    this.componentsMoudel
      .getRequestHander(this.componentsMoudel.getData("urls").userInfo)
      .startGet()
      .then((res) => {
        that.account = res.body.data.account;
        that.companyName = res.body.data.companyName;
      });
    this.loadSystemMessage();
  },
  methods: {
    async loadSystemMessage() {
      try {
        const res = await getLatestSystemMessage();
        const message = res && res.body && res.body.data;
        if (message && message.id) {
          this.systemMessage = message;
        }
      } catch (e) {
        // 公告接口异常不应影响厂商正常使用系统。
      }
    },
    openSystemMessage() {
      if (this.systemMessage) {
        this.systemMessageVisible = true;
      } else {
        this.$message.info('当前没有可查看的系统消息');
      }
    },
    //当前
    refreshAnimation(index) {
      if (this.canvasnav) {
        // 每次切换前重新测量各菜单项的真实位置和宽度，
        // 避免因文字长度变化、菜单溢出收起等导致的高亮框与文字错位。
        this.canvasnav._recalc();
        this.canvasnav._toggle(index);
      } else {
        setTimeout(() => {
          if (this.canvasnav) {
            this.canvasnav._recalc();
            this.canvasnav._toggle(index);
          } else {
            setTimeout(() => {
              if (this.canvasnav) {
                this.canvasnav._recalc();
                this.canvasnav._toggle(index);
              }
            }, 400)
          }
        }, 200)
      }

    },
    //设置动画
    setAnimationFun() {
      this.canvasnav = (function () {
        var c = Math.min,
          h = Math.sign,
          m = Math.max,
          n = Math.abs,
          j = .85,
          k = 10,
          l = 4;
        var opt = {};
        opt.currentIndex = 1;
        opt.canvas = document.getElementById('canvas-2761');


        var calcAVGSpeed = function (a) {
          var b = (l * j * a + k * (1 - j) * a) / (k * l * 20);
          return b = m(n(b), 2.5) * h(b), b
        }
        var getCurSpeed = function (a, b) {
          var c = n(a) > n(j * b) ? l * opt.avgSpeed : k * opt.avgSpeed;
          return c
        }


        var _calCurve = function (a, b, c, d, e, f) {
          //console.log(a + f,b,c-f,d,c,d);
          e.bezierCurveTo(a + f, b, c - f, d, c, d)
        }

        var _initCanvas = function (canvas, width, height) {
          var devicePixelRatio = window.devicePixelRatio,
            canvasObj = canvas.getContext("2d");
          canvas.width = width * devicePixelRatio, canvas.height = height * devicePixelRatio, canvas.style
            .width = width + "px", canvas.style.height = height + "px", canvasObj.scale(devicePixelRatio,
              devicePixelRatio)
        }

        var resize = function () {
          //resize发生
          opt.timer && cancelAnimationFrame(opt.timer);
          _calcTabs();
          _initCanvas(opt.canvas, opt.width, opt.height), draw(0)
        }


        var _calcTabs = function () {
          var titleTab = document.querySelector(".navbar-title");
          var menuItems = document.querySelectorAll(
            ".sidebar-container-mian .recombination-custom-menu > .el-menu > .recombination-first-stage"
          );
          var canvasRect = opt.canvas.getBoundingClientRect();
          var starts = [-20];
          var widths = [0];

          Array.prototype.forEach.call(menuItems, function (item) {
            var rect = item.getBoundingClientRect();
            starts.push(rect.left - canvasRect.left);
            widths.push(rect.width);
          });

          if (menuItems.length) {
            var lastRect = menuItems[menuItems.length - 1].getBoundingClientRect();
            starts.push(lastRect.right - canvasRect.left);
            widths.push(0);
            opt.tabWidthList = starts;
            opt.tabItemWidths = widths;
            opt.tabHeight = menuItems[0].offsetHeight;
            opt.height = opt.tabHeight + 5;
            opt.width = window.innerWidth;
          } else if (titleTab) {
            var titleRect = titleTab.getBoundingClientRect();
            opt.tabWidthList = [-20, titleRect.right - canvasRect.left];
            opt.tabItemWidths = [0, titleRect.width];
            opt.tabHeight = titleTab.offsetHeight;
            opt.height = opt.tabHeight + 5;
            opt.width = window.innerWidth;
          }
        }


        var _toggle = function (navindex) {
          //console.log("进来了= = ", navindex)
          "undefined" !== typeof navindex &&
            navindex !== opt.currentIndex &&
            opt.tabWidthList &&
            opt.tabWidthList.length &&
            (!opt.animating || navindex !== opt.nextIndex) &&
            (opt.animating = true,
              opt.distance = opt.tabWidthList[navindex] - opt.tabWidthList[opt.currentIndex],
              opt.avgSpeed = calcAVGSpeed(opt.distance),
              opt.curDisX = 0,
              opt.nextIndex = navindex
            )
          //console.log("opt = ",opt)
          return false;
        }


        var _createPattern = function (a) {
          var b = 140,
            c = 63,
            d = 1,
            e = document.createElement("canvas");
          e.width = b, e.height = c, e.style.width = b / d + "px", e.style.height = c / d + "px";
          var f = e.getContext("2d");
          //缩放 宽高 100%
          f.scale(d, d);
          f.lineWidth = .4;
          for (var g = 3, h = .8, j = 1; 30 > j; j++) {
            //设置或返回用于笔触的颜色、渐变或模式
            f.strokeStyle = "RGBA(22, 120, 160, " + h + ")";
            //开始一条路径
            f.beginPath();
            //把路径移动到画布中的指定点，不创建线条
            f.moveTo(0, j * g);
            //添加一个新点，然后在画布中创建从该点到最后指定点的线条
            f.lineTo(b, j * g);
            //绘制已定义的路径
            f.stroke();
            //创建从当前点回到起始点的路径
            f.closePath();
            10 < j && (h -= .1);
          }
          var i = a.getContext("2d").createPattern(e, "repeat-x");
          opt.pattern = i, e = null
        }

        var _drawHightlight = function (a) {
          //a = 0
          var b = opt.canvas.getContext("2d"),
            d = .3;
          //clearRect 在给定的矩形内清除指定的像素,这里清完了
          b.clearRect(0, 0, 2 * opt.width, 2 * opt.height);
          b.shadowColor = "rgba(0, 193, 220, 1)";
          b.shadowBlur = 5;
          b.strokeStyle = "#004CB3";
          b.lineWidth = .8;
          b.fillStyle = "none";
          _draw(b, false);
          //这里绘制了外围边框线条
          //return false;
          var e = b.createLinearGradient(0, 0, opt.width, opt.height),
            f = a - d;
          e.addColorStop(c(1, m(0, 0 + f)), "rgba(0,0,0,0)");
          e.addColorStop(c(1, m(0, 0 + f + .1)), "#8ED6FF");
          e.addColorStop(c(1, 0 + f + d), "#8ED6FF");
          e.addColorStop(c(1, 0 + f + d + .1), "rgba(0,0,0,0)");
          e.addColorStop(1, "rgba(0,0,0,0)");
          b.lineWidth = 1.5;
          b.strokeStyle = e;
          b.fillStyle = opt.pattern;
          _draw(b, true)

        }


        var draw = function (a) {
          //console.log(a);
          _drawHightlight(a);
          //return false;

          opt.timer = requestAnimationFrame(function () {
            //console.log(a);
            draw((a + .005) % 1.4)
          })


        }

        var _draw = function (canvasObj, trueorfalse) {
          var navindex = opt.currentIndex,
            tableHeight = opt.tabHeight,
            f = 0,
            g = 40,
            i = 20,
            j = .5,
            k = 2.5,
            l = 0;
          if (canvasObj.beginPath(), canvasObj.moveTo(-50, opt.height + 10), canvasObj.lineTo(-50,
            tableHeight + j), opt.animating) {
            var m = getCurSpeed(opt.curDisX, opt.distance);
            l = c(n(opt.distance), n(opt.curDisX + m)) * h(m)
          }
          if (canvasObj.lineTo(f + opt.tabWidthList[navindex] + l - g / 2, tableHeight + j), _calCurve(f +
            opt.tabWidthList[navindex] + l - g / 2, tableHeight + j, f + opt.tabWidthList[navindex] +
            l + g / 2, k + j, canvasObj, i), opt.animating) {
            var o = opt.tabItemWidths[opt.nextIndex] || 0;
            canvasObj.lineTo(f + opt.tabWidthList[navindex] + o + l - g / 2, k + j), _calCurve(f + opt
              .tabWidthList[navindex] + o + l - g / 2, k + j, f + opt.tabWidthList[navindex] + o +
              l + g / 2, tableHeight + j, canvasObj, i)
          } else {
            canvasObj.lineTo(f + opt.tabWidthList[navindex] + (opt.tabItemWidths[navindex] || 0) + l - g / 2, k + j);
            _calCurve(f + opt.tabWidthList[navindex] + (opt.tabItemWidths[navindex] || 0) + l - g / 2, k + j, f +
              opt.tabWidthList[navindex] + (opt.tabItemWidths[navindex] || 0) + l + g / 2, tableHeight + j, canvasObj, i);
          }

          canvasObj.lineTo(opt.width + 10, tableHeight + j);
          canvasObj.lineTo(opt.width + 10, opt.height + 10);
          canvasObj.closePath();
          canvasObj.stroke();
          trueorfalse && canvasObj.fill();
          opt.animating && trueorfalse && (opt.curDisX = l, n(l) >= n(opt.distance) && (opt.animating =
            false, opt.currentIndex = opt.nextIndex))
        }

        _toggle(1);
        _calcTabs();
        _initCanvas(opt.canvas, opt.width, opt.height);
        _createPattern(opt.canvas);
        draw(0);
        window.onresize = function () {
          resize();
        };

        // 重新测量菜单项真实宽度和位置（不触发切换动画、不打断当前动画状态）。
        // 用于菜单文字内容、字号或可见项发生变化后，让高亮框跟上最新布局。
        var _recalc = function () {
          _calcTabs();
        }

        return {
          "_toggle": _toggle,
          "_recalc": _recalc
        }

      })()


    },
    handleCommand(command) {
      switch (command) {
        case "changeNav":
          this.changeNav(7);
          break;
        case "toMap":
          this.toMap();
          break;
        default:
          break;
      }
    },
    toMap() {
      let manufacturer = localStorage.getItem("manufacturer");
      if (VueCookies.get("token")) {
        // if(window.location.hostname=='localhost'){
        //   location.href="http://localhost:8080/#/HongShengFactory?token="+VueCookies.get("token");
        // }else{
        //   location.href="http://datav."+window.location.host+"/#/HongShengFactory?token="+VueCookies.get("token");
        // }
        //this.$router.push("/datav");
        const companyInfo =JSON.parse(localStorage.getItem('companyInfo'));//TODO:获取租户公司信息
        //this.url = companyInfo.serviceIp+"/autologin?url=largescreen4&name="+companyInfo.serviceUserName+"&code="+companyInfo.serviceCode;
        this.url = companyInfo.serviceIp+"/autologin?url=screen&name="+companyInfo.serviceUserName+"&code="+companyInfo.serviceCode;
        if (companyInfo.abbreviation==="河南爱维"){
          /*if(window.location.hostname=='localhost'){
               location.href="http://localhost:8080/#/HongShengFactory?token="+VueCookies.get("token");
             }else{
               location.href="http://datav."+window.location.host+"/#/HongShengFactory?token="+VueCookies.get("token");
             }*/
          this.$router.push("/datav");
        }else {
          this.$router.push("/peoplePosition");
          /*this.$router.push({
            path: "/processManager/peoplePosition",
          });*/
        }

      }
    },
    changeNav(navid) {
      localStorage.setItem("navItem", localStorage.getItem("navItem" + navid));
      this.$router.push({
        path: "/companyManager/userManager",
      });
    },
    outLogin: function () {
      this.$alert("确定注销并退出系统吗？", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action != "confirm") {
            return;
          }
          this.componentsMoudel
            .getRequestHander(this.componentsMoudel.getData("urls").outLogin)
            .openLoad()
            .startGet()
            .then((res) => {
              this.componentsMoudel.clearLocalStorage();
              localStorage.clear();
              var keys = document.cookie.match(/[^ =;]+(?==)/g);
              if (keys) {
                for (var i = keys.length; i--;) {
                  document.cookie =
                    keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); // 清除当前域名下的,例如：m.ratingdog.cn
                  document.cookie =
                    keys[i] +
                    "=0;path=/;domain=" +
                    document.domain +
                    ";expires=" +
                    new Date(0).toUTCString(); // 清除当前域名下的，例如 .m.ratingdog.cn
                  document.cookie =
                    keys[i] +
                    "=0;path=/;domain=ratingdog.cn;expires=" +
                    new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .ratingdog.cn
                }
              }
              this.$router.push({
                path: "/",
              });
            });
        },
      });
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs['navbarId']) {
        this.setAnimationFun()
      } else {
        setTimeout(() => {
          if (this.$refs['navbarId']) {
            this.setAnimationFun()
          }
        }, 200)
      } setTimeout(() => {
        if (this.$refs['navbarId']) {
          this.setAnimationFun()
        } else {
          setTimeout(() => {
            if (this.$refs['navbarId']) {
              this.setAnimationFun()
            } else {
              setTimeout(() => {
                if (this.$refs['navbarId']) {
                  this.setAnimationFun()
                }
              }, 1000)
            }
          }, 200)
        }
      }, 200)
    }, 50)
  },
  watch: {},
};
</script>

<style lang="scss"  >
.custom-navigation-main {
  .el-dropdown-menu__item {
    padding: 5px 10px !important;
    font-size: 14px;
    color: #606266;
  }

  .custom-navigation-design {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .mar {
      width: 10px;
      height: 1px;
      display: block;
    }
  }

  .logout {
    min-width: 140px !important;
  }

  .el-dropdown-menu__item--divided:before {
    margin: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.navbar-layout {
  position: fixed;
  width: 100%;
  height: 60px;
  background: #1f2d3d;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 99;

  .navbar-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .navbar-title {
      flex: 0 0 190px;
      width: 190px;
      max-width: 190px;
      height: 60px;
      line-height: 60px;
      padding: 0;
      color: #fff;
      font-size: 15px;
      margin-left: 10px;
      margin-right: 10px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .navbar-fixt {
      display: none;
    }

    .sidebar-container-mian {
      position: relative;
      flex: 1 1 auto;
      width: 0;
      min-width: 0;
      height: 54px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      z-index: 9;
    }

    .right-menu {
      flex: 0 0 84px;
      width: 84px;
      height: 100%;
      margin-right: 4px;
      display: flex;
      justify-content: center;
      align-items: center;

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background 0.3s;

          &:hover {
            background: rgba(0, 0, 0, 0.025);
          }
        }
      }

      .avatar-wrapper {
        max-width: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;

        .user-name-mian {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-flow: column;
          height: 70px;

          .user-img {
            width: 100%;
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;

            .el-icon-s-custom {
              font-size: 24px;
              color: #fff;
            }
          }

          .user-name {
            max-width: 72px;
            margin-top: 5px;
            font-size: 12px;
            color: #fff;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 24px;
          font-size: 16px;
          color: #fff;
        }
      }
    }
    .system-message-broadcast {
      display: flex;
      align-items: center;
      flex: 0 0 210px;
      width: 210px;
      min-width: 210px;
      max-width: 210px;
      height: 30px;
      margin-left: 8px;
      margin-right: 8px;
      padding: 0 8px;
      overflow: hidden;
      border: 1px solid rgba(245, 108, 108, 0.9);
      border-radius: 15px;
      color: #f56c6c;
      background: rgba(245, 108, 108, 0.08);
      text-align: left;
      white-space: nowrap;
      font-size: 12px;
    }

    .system-message-broadcast:hover {
      color: #ff4d4f;
      background: rgba(245, 108, 108, 0.16);
    }

    .system-message-broadcast > i {
      flex: 0 0 auto;
      margin-right: 8px;
      font-size: 16px;
    }

    .system-message-broadcast-viewport {
      display: block;
      flex: 1 1 auto;
      overflow: hidden;
      white-space: nowrap;
    }

    .system-message-broadcast-track {
      display: inline-flex;
      align-items: center;
      min-width: max-content;
      animation: system-message-broadcast 24s linear infinite;
    }

    .system-message-broadcast-track > span {
      display: inline-block;
      padding-right: 100px;
    }

    @keyframes system-message-broadcast {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(-50%);
      }
    }

    .system-message-title {
      margin-bottom: 12px;
      color: #303133;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.5;
    }

    .system-message-meta {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 18px;
      color: #909399;
      font-size: 13px;
    }

    .system-message-content {
      min-height: 100px;
      max-height: 360px;
      overflow-y: auto;
      padding: 14px;
      color: #606266;
      background: #f5f7fa;
      border-radius: 4px;
      white-space: pre-wrap;
      word-break: break-word;
      line-height: 1.8;
    }
  }

}
</style>
<style>
#canvas-2761 {
  height: 55px !important;
}
</style>
